export default __webpack_public_path__ + "static/media/linode-horizontal.2a2a9a59.svg";